<template>
  <div role="menu" :aria-label="$t('components.kendoGrid.columnMenuAriaLabel', { column: column ? column.title : '' })">
    <GridColumnMenuSort v-if="sortable"
      :column="column"
      :sortable="sortable"
      :sort="sort"
      @closemenu ="closeMenu"
      @sortchange = "sortChange"/>
    <GridColumnMenuItemGroup>
    <GridColumnMenuItem
        :title="$t('components.kendoGrid.showHideColumns')"
        :icon-class="'k-i-columns'"
        @menuitemclick="onMenuItemClick"
    />
    <GridColumnMenuItemContent :show="columnsExpanded">
      <div class='k-column-list-wrapper'>
        <form @submit="onSubmit" @reset="onReset">
          <div class='k-column-list' role="group" :aria-label="$t('components.kendoGrid.visibleColumns')">
            <div :key="idx" class='k-column-list-item' v-for="(column, idx) in currentColumns">
              <span>
                <input
                  :id="'column-visiblity-show-' + idx"
                  :class="'k-checkbox'"
                  :type="'checkbox'"
                  :readOnly="true"
                  :disabled="!column.hidden && oneVisibleColumn"
                  :checked="!column.hidden"
                  :aria-label="$t('components.kendoGrid.showColumn', { column: column.title })"
                  @click="onToggleColumn(idx)"
                />
                <label
                  :for="'column-visiblity-show-' + idx"
                  :class="'k-checkbox-label'"
                  :style="{ userSelect: 'none' }"
                >
                  {{column.title}}
                </label>
              </span>
            </div>
          </div>
          <div class='k-columnmenu-actions'>
            <button :aria-label="$t('components.kendoGrid.showAllColumns')" type='reset' class='k-button'>{{ $t('components.kendoGrid.showAllColumns') }}</button>
            <button :aria-label="$t('components.kendoGrid.saveColumnsConfig')" class='k-button k-primary'>{{ $t('components.kendoGrid.saveColumnsConfig') }}</button>
          </div>
        </form>
      </div>
    </GridColumnMenuItemContent>
    </GridColumnMenuItemGroup>
    <GridColumnMenuItem
      :title="$t('components.kendoGrid.lockUnlockColumn')"
      :icon-class="'k-i-columns'"
      @menuitemclick="lockUnlockColum(column)"
    />
  </div>
</template>
<script>
import {
  GridColumnMenuSort,
  GridColumnMenuItemGroup,
  GridColumnMenuItemContent,
  GridColumnMenuItem
} from '@progress/kendo-vue-grid'

export default {
  props: {
    column: Object,
    sortable: [Boolean, Object],
    sort: {
      type: Array
    },
    filter: Object,
    filterable: Boolean,
    columns: Array
  },
  data () {
    return {
      currentColumns: [],
      columnsExpanded: false,
      filterExpanded: false
    }
  },
  components: {
    GridColumnMenuSort,
    GridColumnMenuItemGroup,
    GridColumnMenuItemContent,
    GridColumnMenuItem
  },
  computed: {
    oneVisibleColumn: function () {
      return this.currentColumns.filter(c => !c.hidden).length === 1
    },
    numLocked: function () {
      return this.currentColumns.filter(x => x.locked).length
    }
  },
  created: function () {
    this.$data.currentColumns = this.$props.columns
  },
  mounted: function () {
    this.$nextTick(() => {
      this.setupMenuItemRoles()
    })
  },
  methods: {
    onToggleColumn (id) {
      this.currentColumns = this.currentColumns.map((column, idx) => {
        return idx === id ? { ...column, hidden: !column.hidden } : column
      })
    },
    onReset (event) {
      event.preventDefault()
      const allColumns = this.$props.columns.map(col => {
        return {
          ...col,
          hidden: false
        }
      })

      this.currentColumns = allColumns
      this.onSubmit()
    },
    onSubmit (event) {
      if (event) {
        event.preventDefault()
      }
      this.$emit('columnssubmit', this.currentColumns)
      this.$emit('closemenu')
    },
    onMenuItemClick () {
      const value = !this.columnsExpanded
      this.columnsExpanded = value
      this.filterExpanded = value ? false : this.filterExpanded
    },
    onFilterExpandChange (value) {
      this.filterExpanded = value
      this.columnsExpanded = value ? false : this.columnsExpanded
    },
    expandChange () {
      this.$emit('expandchange')
    },
    closeMenu () {
      this.$emit('closemenu')
    },
    filterChange (newDescriptor, e) {
      this.$emit('filterchange', newDescriptor, e)
    },
    sortChange (newDescriptor, e) {
      this.$emit('sortchange', newDescriptor, e)
    },
    setupMenuItemRoles: function () {
      try {
        const el = this.$el
        if (!el) return
        
        // Configurar items de ordenación como menuitemradio
        const sortItems = el.querySelectorAll('.k-columnmenu-item, .k-sort-order')
        sortItems.forEach((item) => {
          if (!item.getAttribute('role')) {
            item.setAttribute('role', 'menuitemradio')
          }
          // Marcar si está seleccionado
          const isSelected = item.classList.contains('k-state-selected') || item.classList.contains('k-selected')
          item.setAttribute('aria-checked', isSelected ? 'true' : 'false')
        })
        
        // Configurar items de menú genéricos
        const menuItems = el.querySelectorAll('.k-menu-item, .k-item')
        menuItems.forEach((item) => {
          if (!item.getAttribute('role')) {
            item.setAttribute('role', 'menuitem')
          }
        })
      } catch (error) {
        console.error('Error configurando roles ARIA en ColumnMenu:', error)
      }
    },
    lockUnlockColum: function (currentColumn) {
      this.currentColumns = this.currentColumns.map((column) => {
        return column.field === currentColumn.field ? { ...column, locked: !column.locked, reorderable: column.locked } : column
      })
      // this.currentColumns = this.currentColumns.sort(compare)
      // Fix TMP Bug Lock => Reorder => Unlock
      this.currentColumns = this.currentColumns.map((column) => {
        if (this.numLocked > 0) column.reorderable = false
        else column.reorderable = true
        return column
      })
      this.$emit('columnssubmit', this.currentColumns)
      this.$emit('closemenu')
    }
  }

}
// function compare (a, b) {
//   if (a.locked > b.locked) {
//     return -1
//   }
//   if (a.locked < b.locked) {
//     return 1
//   }
//   return 0
// }
</script>
